import { render, staticRenderFns } from "./OpenInvoices.vue?vue&type=template&id=fe4f2160&scoped=true"
import script from "./OpenInvoices.vue?vue&type=script&lang=js"
export * from "./OpenInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4f2160",
  null
  
)

export default component.exports